export enum ROUTES {
  // Credits section
  CREDITS_LANDING = '/credits',
  CREDITS_FAQ = '/credits/faq',
  CREDITS_INTEREST_PAGE = '/credits/interest',
  CREDITS_STOREFRONT = '/credits/storefront',
  CREDITS_STORE = '/credits/store',
  INTAKE_PAGE = '/credits/interest/intake',
  INTAKE_PAGE_STEP_1 = '/credits/interest/intake/step-1',
  INTAKE_PAGE_STEP_2 = '/credits/interest/intake/step-2',
  PRODUCT_PAGE_ROOT = '/credits/product',
  PRODUCT_PAGE = '/credits/product/:asin',
  CHECKOUT_PAGE = '/credits/product/:asin/checkout/:entitlementId?',

  // Credits segments section
  CREDITS_SEGMENT_REDUCE_DEFORESTATION = '/credits/segments/reduce-deforestation',
  CREDITS_SEGMENT_RESTORING_FORESTS = '/credits/segments/restoring-forests',
  CREDITS_SEGMENT_TECH_CARBON_REMOVAL = '/credits/segments/tech-carbon-removal',
  CREDITS_SEGMENT_SUPERPOLLUTANTS = '/credits/segments/superpollutants',
  CREDITS_SEGMENT_LOWER_CARBON_FUELS = '/credits/segments/lower-carbon-fuels',

  // Account section (routes served by AsxMyAccountWebsite, kept for intake-form references)
  MY_ACCOUNT_PAGE = '/account',
  SUMMARY_PAGE = '/account/summary',

  // Sign in page (redirects from mons only)
  SIGN_IN_PAGE = '/sign-in',

  // Sign out page
  SIGN_OUT_PAGE = '/sign-out',

  // Error page
  ERROR_PAGE = '/error',

  // 404 not found
  NOT_FOUND = '/404',

  CONTACT_BUYER_SUPPORT = 'mailto:amazon-carbon-credits-us@amazon.com',
  CONTACT_SUPPLIER_SUPPORT = 'mailto:supplier-sustainability-support@amazon.com',
}
